var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tabs-container"},_vm._l((_vm.tabs),function(tab,index){return _c('tws-nav-link',{key:tab.title,staticClass:"tab",class:{ 'tab--active': index === _vm.activeTabIndex },attrs:{"href":tab.link}},[_vm._v(" "+_vm._s(tab.title)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }